import { IconCoinOff } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { mergeWith, subtract } from 'lodash-es';
import { clone, isNonNullish } from 'remeda';
import {
  type AgedBalanceCompact,
  useLoadAgedBalanceCompact,
} from 'shared/hooks/use-load-aged-balance';
import { useLoadDisputedInvoices } from 'shared/hooks/use-load-disputed-invoices';
import { useSafeLocalizedCompactCurrencyFormatter } from 'shared/utils/currency';

import { BaseTicker } from '../BaseTicker';

function getShareDisputed(agedBalanceCompact: AgedBalanceCompact, disputedAmount: number) {
  const netAgedBalance = mergeWith(
    clone(agedBalanceCompact.debits),
    agedBalanceCompact.credits,
    subtract,
  );

  const totalReceivable =
    netAgedBalance.notDue +
    netAgedBalance['0'] +
    netAgedBalance['30'] +
    netAgedBalance['60'] +
    netAgedBalance['90'];

  return disputedAmount / totalReceivable;
}

export const DisputedTicker = () => {
  const { t } = useTranslation();
  const { agedBalanceCompact, agedBalanceCompactError, isAgedBalanceCompactLoading } =
    useLoadAgedBalanceCompact();
  const { disputedInvoices, disputedInvoicesError, isDisputedInvoicesLoading } =
    useLoadDisputedInvoices();
  const formatter = useSafeLocalizedCompactCurrencyFormatter();

  if (
    isAgedBalanceCompactLoading ||
    agedBalanceCompact == null ||
    isDisputedInvoicesLoading ||
    disputedInvoices == null
  ) {
    return (
      <BaseTicker
        icon={IconCoinOff}
        label={t(i18nKeys.ANALYTICS.TICKERS.DISPUTED.TITLE)}
        hasFailed={isNonNullish(agedBalanceCompactError) || isNonNullish(disputedInvoicesError)}
      />
    );
  }

  return (
    <BaseTicker
      icon={IconCoinOff}
      label={t(i18nKeys.ANALYTICS.TICKERS.DISPUTED.TITLE)}
      value={formatter.format(disputedInvoices)}
      share={getShareDisputed(agedBalanceCompact, disputedInvoices)}
      url="/invoices?status=disputed"
    />
  );
};
